import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MyClientsReSignRequestModel } from '../models/myClientsReSignRequest.model';
import { MyClientsReSingRespondeModel } from '../models/myClientsReSingResponse.model';
import { Observable } from 'rxjs';
import { MyClientsReSignEmailFauRequestModel } from '../models/myClientsReSingEmailRequest.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyClientsService {
  private url: string;
  private urlSendEmail: string;
  public token: string = '';
  
  constructor(
    private http: HttpClient
  ) { 
    this.url = environment.urlApi;
    this.urlSendEmail = `${environment.urlApiDev}/buyerInt`;
  }

  getClientData(params: MyClientsReSignRequestModel) : Observable<MyClientsReSingRespondeModel> {
    const headers: HttpHeaders = new HttpHeaders({
      'token':  this.getTokenAlt() || '' 
    });

    const options = {
      headers,
      params: params as any
    };
    
    return this.http.get<MyClientsReSingRespondeModel>(`${this.url}/pr_comprador_firma_fau`, options);
  }

  sendEmailReSignFau(params: MyClientsReSignEmailFauRequestModel) : Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:  'Basic '+btoa(environment.buyerIntApiKey)
    });

    return this.http.post<any>(`${this.urlSendEmail}/validar_otp/correoCompradorRefirmaFirmaDigital`, params, { headers });
  }

  getTokenAlt() {
    const token = sessionStorage.getItem('tokenALT');
    if ( token ) {
      return token;
    }
  }

}
